import { render, staticRenderFns } from "./FeatureDetailWithColumns.vue?vue&type=template&id=4cab9ba0&scoped=true&"
import script from "./FeatureDetailWithColumns.vue?vue&type=script&lang=ts&"
export * from "./FeatureDetailWithColumns.vue?vue&type=script&lang=ts&"
import style0 from "./FeatureDetailWithColumns.vue?vue&type=style&index=0&id=4cab9ba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cab9ba0",
  null
  
)

export default component.exports